import { Outlet } from 'react-router-dom';

function SMS() {
  return <Outlet />;
}

export default SMS;
